import { render, staticRenderFns } from "./weixinLogin.vue?vue&type=template&id=4ef9cd93&"
import script from "./weixinLogin.vue?vue&type=script&lang=js&"
export * from "./weixinLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports